import React from 'react';
import i18n from 'i18n';

import styles from './index.module.scss';

const FallbackComponent = () => <div className={styles.container}>{i18n.t('app.error')}</div>;

export default FallbackComponent;
